import { LineChartDirective } from './charts/line/line.directive';
import { PanelComponent } from './charts/panel/panel.component';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule, Http, RequestOptions } from '@angular/http';
import { DashboardComponent } from './dashboard/dashboard.component';
import { StatsComponent } from './stats.component';
import { PieChartComponent, LineChartComponent, TableChartComponent } from './charts/';
import { AuthService } from '../auth/auth.service';
import { AuthGuard } from '../auth/auth.guard';
import { StatsService } from './stats.service';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { Ng2TableModule } from 'ng2-table';
import { TranslateModule } from '@ngx-translate/core';
import { router } from './stats.routes';
import { StatsResolver } from './stats.resolver';
import { ThemeResolver } from '../../theme/theme.resolver';

@NgModule({
  declarations: [
    DashboardComponent,
    StatsComponent,
    PieChartComponent,
    LineChartComponent,
    TableChartComponent,
    LineChartDirective,
    PanelComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    TranslateModule,
    Ng2TableModule,
    router,
    TabsModule.forRoot(),
    PaginationModule.forRoot(),
    BsDropdownModule.forRoot()
  ],
  exports: [StatsComponent],
  entryComponents: [DashboardComponent, LineChartComponent],
  providers: [AuthGuard, StatsService, AuthService, StatsResolver, ThemeResolver]
})
export class StatsModule {}



// WEBPACK FOOTER //
// ./src/app/modules/stats/stats.module.ts